import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllContasReceberDeletadasUseCase } from "../../../presentation/useCases/read/get_all_contas_receber_deletadas_use_case";
import { ContasReceberLista } from "../../models/contas_receber_lista";
import { ContasReceberListaFilter } from "../../models/contas_receber_lista_filter";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetAllContasReceberDeletadasUseCase
 */


export class GetAllContasReceberDeletadasUseCase extends BasePaginatedUseCase<ContasReceberLista> implements IGetAllContasReceberDeletadasUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }

  async getAllContasReceberDeletadas(
    filter: ContasReceberListaFilter,
    page: number,
    rowsPerPage: number): Promise<void> {
    const result = await this.repository.getAllContasReceberDeletadas(filter, page, rowsPerPage);

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
  }


}

